import defaultStyles from "./why-customers-trust-default.module.scss";
import mobileStyles from "./why-customers-trust-mobile.module.scss";
import DomPurify from "isomorphic-dompurify";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LayoutStyleTypes, LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import classNames from "classnames";
import { FixBreadcrumb, useBreadcrumbs } from "@/elements-react/fix-breadcrumb";
import { Url } from "@/helpers/url.ts";

export function useWhyCustomersTrustCommon(staticPageContent: string) {
  const { t } = useTranslation();
  const { layoutType } = useLayoutType();

  const isMobile = layoutType === LayoutTypes.TYPE_MOBILE;
  const additionalStyles = isMobile ? mobileStyles : defaultStyles;

  const content = useMemo(() => {
    return DomPurify.sanitize(staticPageContent);
  }, [staticPageContent]);

  const breadcrumbs = [
    {
      label: t("94kf48j3f729584n.whyCustomersTrust", "Why customers trust us"),
      url: Url.to("why-customers-trust-us-page"),
    },
  ];

  useBreadcrumbs(breadcrumbs);

  const renderContent = () => {
    const contentClassnames = classNames({
      [defaultStyles[LayoutStyleTypes.TYPE_SM]]: isMobile,
    });

    return (
      <div className={defaultStyles.wrapper}>
        <div className={contentClassnames}>
          <div class="static-page-content">
            <div className={defaultStyles.breadcrumbsNavigation}>
              <FixBreadcrumb />
            </div>

            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </div>
    );
  };

  return {
    renderContent,
  };
}
